module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "widget"
  }, [(!_vm.$slots.header) ? _c('div', {
    staticClass: "widget-header clearfix"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('h3', [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('ul', {
    staticClass: "tool-btn"
  }, [_c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.collapsed = !_vm.collapsed
      }
    }
  }, [_c('i', {
    staticClass: "fa ",
    class: {
      'fa-chevron-up': !_vm.collapsed,
      'fa-chevron-down': _vm.collapsed,
    }
  })])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": _vm.close
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  })])])])]) : _vm._e(), _vm._v(" "), (_vm.$slots.header) ? _c('div', {
    staticClass: "widget-header"
  }, [_vm._t("header")], 2) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.collapsed),
      expression: "!collapsed"
    }],
    staticClass: "body"
  }, [_vm._t("default")], 2), _vm._v(" "), (_vm.$slots.footer) ? _c('div', {
    staticClass: "footer"
  }, [_vm._t("footer")], 2) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.11.1.4@vue-loader/lib/template-compiler.js?{"id":"data-v-258dabdf"}!./~/.11.1.4@vue-loader/lib/selector.js?type=template&index=0!./src/packages/widget/src/Widget.vue
// module id = 243
// module chunks = 0